"use client";

import { useEffect, useRef, useState } from "react";

export default function SaveAsDialog({ locale, initialName, busy, error, onClose, onSubmit }: {
  locale: string;
  initialName: string;
  busy: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (name: string) => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const [name, setName] = useState(initialName.slice(0, 160));
  const isPl = locale === "pl";
  useEffect(() => {
    const element = dialog.current;
    element?.showModal();
    return () => element?.close();
  }, []);

  return (
    <dialog ref={dialog} aria-labelledby="save-as-title"
      className="m-auto w-[480px] max-w-[94vw] rounded-xl border border-white/15 bg-[#0f141d] p-6 text-white shadow-2xl backdrop:bg-black/60"
      onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}>
      <form onSubmit={event => { event.preventDefault(); if (!busy && name.trim()) onSubmit(name.trim()); }}>
        <h2 id="save-as-title" className="text-lg font-semibold">{isPl ? "Zapisz jako" : "Save as"}</h2>
        <p className="mt-2 text-sm text-white/70">
          {isPl
            ? "Utworzymy osobny projekt z aktualnymi stronami, okładką i zdjęciami. Dalsze zmiany w kopii nie wpłyną na oryginał."
            : "Create a separate project with the current pages, cover and photos. Further changes to the copy will not affect the original."}
        </p>
        <label className="mt-5 block text-sm" htmlFor="save-as-name">{isPl ? "Nazwa nowego projektu" : "New project name"}</label>
        <input id="save-as-name" autoFocus required maxLength={160} disabled={busy} value={name}
          onChange={event => setName(event.target.value)}
          className="mt-2 w-full rounded-lg border border-white/20 bg-white/5 px-3 py-2 text-sm outline-none focus:border-white/60" />
        {error ? <p role="alert" className="mt-3 text-sm text-red-300">{error}</p> : null}
        {busy ? <p role="status" className="mt-3 text-sm text-white/70">{isPl ? "Kopiowanie projektu i zdjęć…" : "Copying project and photos…"}</p> : null}
        <div className="mt-6 flex justify-end gap-3">
          <button type="button" disabled={busy} onClick={onClose} className="editor-secondary-button px-4 py-2 text-sm disabled:opacity-50">{isPl ? "Anuluj" : "Cancel"}</button>
          <button type="submit" disabled={busy || !name.trim()} className="rounded-lg bg-white px-4 py-2 text-sm font-semibold text-[#0f141d] disabled:opacity-50">
            {isPl ? "Zapisz i otwórz kopię" : "Save and open copy"}
          </button>
        </div>
      </form>
    </dialog>
  );
}
